import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { OAuthModule } from 'angular-oauth2-oidc';
import { SHARED_CONFIG, SharedConfig, TWO_FACTOR_VERIFICATION_SERVICE } from './models';
import { TWO_FACTOR_AUTHENTICATION_SERVICE } from './models/two-factor-authentication';
import {
  AuthInterceptor,
  JwtInterceptor,
  LoadingInterceptor,
  MaintenanceInterceptor,
} from './services';
import { TwoFactorAuthenticationService } from './services/two-factor-authentication.service';
import { TwoFactorVerificationService } from './services/two-factor-verification.service';
import { routes } from './shared.routes';

@NgModule(
  {
    imports: [
      RouterModule.forChild(routes),
    ],
    providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: LoadingInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: JwtInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthInterceptor,
        multi: true,
      },
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MaintenanceInterceptor,
        multi: true,
      },
      { provide: TWO_FACTOR_VERIFICATION_SERVICE, useClass: TwoFactorVerificationService },
      { provide: TWO_FACTOR_AUTHENTICATION_SERVICE, useClass: TwoFactorAuthenticationService },
      ...(OAuthModule.forRoot().providers ?? []),
    ],
  },
)
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class SharedModule {
  public static forRoot(sharedConfig: SharedConfig): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        {
          provide: SHARED_CONFIG,
          useValue: sharedConfig,
        },
      ],
    };
  }
}
